import CreatableSelect from 'react-select/creatable';
import { doubleStyles, toSelectFormat } from './utils';

const PowerFilter = ({
  powerOptions,
  selectValues,
  powerConfig,
  handleChange,
  isDisabled,
  label,
  isSelectedFormat = true,
  placeholders,
}) => {
  const validatePowerFrom = from => {
    const min = powerConfig.minimum;
    const max = powerConfig.maximum;
    const to = selectValues.powerToOption || max;
    if (from < min || from > max || from > to) {
      handleChange('powerFromOption', null);
    } else {
      handleChange('powerFromOption', isSelectedFormat ? toSelectFormat(from) : from);
    }
  };

  const validatePowerTo = to => {
    const min = powerConfig.minimum;
    const max = powerConfig.maximum;
    const from = selectValues.powerFromOption || min;
    if (to < min || to > max || to < from) {
      handleChange('powerToOption', null);
    } else {
      handleChange('powerToOption', isSelectedFormat ? toSelectFormat(to) : to);
    }
  };
  return (
    <div className={`double__select ${isDisabled && 'is-disabled'}`}>
      <div style={{ position: 'relative' }}>
        <CreatableSelect
          options={powerOptions}
          placeholder={placeholders ? 'Desde' : 'Fuerza desde'}
          styles={doubleStyles}
          onCreateOption={value => validatePowerFrom(value)}
          value={toSelectFormat(selectValues.powerFromOption)}
          onChange={selectedOption => validatePowerFrom(selectedOption.value)}
          classNamePrefix="select"
          formatCreateLabel={inputValue => inputValue}
          isDisabled={isDisabled}
        />
        {!isDisabled && <p className="select-right-indicator">{label}</p>}
      </div>
      <div style={{ position: 'relative' }}>
        <CreatableSelect
          options={powerOptions}
          placeholder={placeholders ? 'Hasta' : 'Fuerza hasta'}
          styles={doubleStyles}
          onCreateOption={value => validatePowerTo(value)}
          value={toSelectFormat(selectValues.powerToOption)}
          onChange={selectedOption => validatePowerTo(selectedOption.value)}
          classNamePrefix="select"
          formatCreateLabel={inputValue => inputValue}
          isDisabled={isDisabled}
        />
        {!isDisabled && <p className="select-right-indicator">{label}</p>}
      </div>
    </div>
  );
};

export default PowerFilter;
